<template>
	<div class="brick view_brick">
		<div class="view_inner">
			<table vclass="view_tbl">
				<colgroup>
					<col style="width:180px;" />
					<col style="width:120px;" />
				</colgroup>
				<tbody>
					<tr>
						<th>Android Version</th>
						<td>
							<input type="text" v-model="and_version_code" class="tbl_int sm_int al_right" style="width:230px;" @focus="$event.target.select()" />
						</td>
					</tr>
					<tr>
						<th>iOS Version</th>
						<td>
							<input type="text" v-model="ios_version_code" class="tbl_int sm_int al_right" style="width:230px;" @focus="$event.target.select()" />
						</td>
					</tr>
				</tbody>
			</table>

			<div class="view_bottom_bt">
				<a href="javascript:;" @click="submit()" type="button" class="search_bt">Save</a>
			</div>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiGetGlobalSettings, apiUpdateAppVersion } from '@/api/basicinfo/systemsetting.js';

export default {
	data: function() {
		return {
			backUri: '/',

			and_version_code: 0,
			ios_version_code: 0,
			//company: {},

			users: [],

			//settings: [],
			//fav_menus: [],

			//modalName: '',
			//showModal: false,
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {},
	methods: {
		async getGlobalSettings() {
			const { data } = await apiGetGlobalSettings();
			this.and_version_code = data.appVersion.and_version_code;
			this.ios_version_code = data.appVersion.ios_version_code;
			//console.log(data);
			// this.company = data.company;
			// this.settings = data.settingList;
		},
		async submit() {
			const { data } = await apiUpdateAppVersion({
				and_version_code: this.and_version_code,
				ios_version_code: this.ios_version_code,
			});

			if (data.result) {
				this.$toast.success('Saved successfully');

				this.getGlobalSettings();
			} else {
				this.$toast.error(data.msg);
			}
		},
	},
	created() {
		this.backUri = '/';
		//console.log(this.menus);
		//console.log(this.fav_menus);

		//this.$store.sideIndex = 9;
		this.$store.commit('setSideIndex', 9);
		this.$store.commit('setSelectedMenu', 'nav_li_global_settings');
		this.$store.commit('setSubTitle', 'Basic Information -> Global Settings');

		this.getGlobalSettings();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
